document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (menu) menu.classList.toggle('open');
});

(function () {
  const root = document.querySelector('[data-planting-calendar]');
  const dataEl = document.getElementById('PlantingCalendarData');
  if (!root || !dataEl) return;

  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (error) { return; }

  const body = root.querySelector('[data-calendar-body]');
  const buttons = root.querySelectorAll('[data-zone]');
  const months = Array.from({ length: 12 }, (_, index) => index);

  function marker(type) {
    return '<span class="plant-marker plant-marker--' + type + '" title="' + type + '"></span>';
  }

  function render(zone) {
    const crops = data[zone] || data['7-8'];
    body.innerHTML = crops.map((crop) => {
      const cells = months.map((month) => {
        let marks = '';
        if (crop.sow.indexOf(month) > -1) marks += marker('sow');
        if (crop.transplant.indexOf(month) > -1) marks += marker('transplant');
        if (crop.harvest.indexOf(month) > -1) marks += marker('harvest');
        return '<td><div class="plant-marker-stack">' + marks + '</div></td>';
      }).join('');
      return '<tr><td class="crop-cell"><span>' + crop.emoji + '</span>' + crop.name + '</td>' + cells + '</tr>';
    }).join('');
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      buttons.forEach((other) => {
        other.classList.remove('is-active');
        other.setAttribute('aria-selected', 'false');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-selected', 'true');
      render(button.dataset.zone);
    });
  });

  render('7-8');
})();
